import { render, staticRenderFns } from "./proveedoresExtradata.vue?vue&type=template&id=0b83600d&"
import script from "./proveedoresExtradata.vue?vue&type=script&lang=js&"
export * from "./proveedoresExtradata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports